import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { DomService } from 'app/components/dom/dom.service';
import { ExhibitorProfileService } from 'app/components/exhibitor-profile/exhibitor-profile.service';
import { CatalogueService } from 'app/components/catalogue/catalogue.service';
import { ExhitorsService } from 'app/components/exhitors/exhitors.service';
import { OdsService } from 'app/components/ods/ods.service';
import { SearchService } from 'app/components/search/search.service';
import { MapsService } from 'app/components/maps/maps.service';
import { UtilsService } from 'app/components/utils/utils.service';
import { DetailsService } from 'app/components/details/details.service';

import { FiltersService } from 'app/components/filters/filters.service';

import { ProductsService } from 'app/components/products/products.service';
import { SessionService } from 'app/components/common/session/session.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LoginService } from 'app/components/login/login.service';
import { MatDialog } from '@angular/material/dialog';


@Component({
  selector: 'app-exhibitor-backoffice-product-detail',
  templateUrl: './exhibitor-backoffice-product-detail.component.html',
  styleUrls: ['./exhibitor-backoffice-product-detail.component.css']
})
export class ExhibitorBackofficeProductDetailComponent implements OnInit, OnDestroy {

  buttonLink: string = '';

  profile: object = {};

  exhibitorData: object = {
    exhibitor: {},
    exhibitorId: null
  };

  @Input() exhibitor: any;
  @Input() videoEmbed: string = '';
  @Input() mapsActive: boolean = false;
  @Input() eventData: any;

  activeImage: any;
  catalogueProperties: any = {};

  unifiedCategories: any = [];
  productId;
  catalogueId;
  exhibitorId;
  productDetail: any = {};

  projection: any = {};
  productsDetail: any[] = [];

  loader: any = {
    count: 0
  };
  alertType: string = '';
  alertMessage: string = '';


  type:string = 'PRODUCT';

  data: any;

  eventName;
  images;
  productCategories;
  hierarchicalProperties;
  files = [];
  socialNetworks;
  imageUrl;


  constructor(public sessionService: SessionService, private activatedRoute:ActivatedRoute,private exhitorsService:ExhitorsService, 
    public catalogueService:CatalogueService, private productsService:ProductsService, private searchService:SearchService,
    public utilsService:UtilsService, private router:Router, public translateService: TranslateService, public detailsService:DetailsService, 
    private loginService:LoginService, private exhibitorSvc: ExhitorsService, public dialog: MatDialog,
    private filtersService:FiltersService, private domService: DomService) {

    this.eventName = this.activatedRoute.snapshot.paramMap.get('event') || null;

    this.exhibitorId = this.activatedRoute.snapshot.paramMap.get('exhibitorId') || null;
    this.productId = this.activatedRoute.snapshot.paramMap.get('productId') || null;
    this.eventName = this.activatedRoute.snapshot.paramMap.get('event') || null;
    this.buttonLink = this.catalogueService.getProperty('id')  + '/' + this.eventName + '/exhibitor-backoffice/exhibitors/' + this.exhibitorId + '/products/' + this.productId + '/product-detail-edit'

  }


  updateExhibitorId(){

    let getProjectionIn = {
      exhibitorId: this.exhibitorId,
      projection: 'forProductDetail'
    };

    let getProductsDetailsIn = {
      productId: this.productId,
      projectionType: 'detail'
    };

    let getExhibitorMainImageUrlIn = {
      exhibitorId: this.exhibitorId
    };


    //this.getProductsExhibitorDetails(getProductsDetailsIn);
    this.getProjection(getProjectionIn);
    this.getExhibitorMainImageUrl(getExhibitorMainImageUrlIn);

  }

  setActiveImage(image) {
    this.activeImage = image;
  }

  setImage(url: string) {
    return url ? url : this.catalogueProperties.defaultProductImage  || 'assets/img/no_image_available.png';
  }

  openMapInNewTab() {
    // Lógica para abrir el mapa en una nueva pestaña
  }

  setExhibitorImage(url: string): string {
    // Lógica para establecer la imagen del expositor
    return url;
  }

  _api(transition, property){
    return this.utilsService._api(transition, property);
  }

  //Extraer

  isEmpty(obj: any): boolean {
    return !obj || obj.length === 0;;
  }

  removeExtFromUrlFile(url: string): string {
    return '';
  }

  fixUrl(url: string): string {
    if (!/^https?:\/\//i.test(url)) {
      return 'http://' + url;
    }
    return url;
  }

  exhibitorHasSocialNetworks(exhibitor: any): boolean {
    return exhibitor && exhibitor.socialNetworks && exhibitor.socialNetworks.length > 0;
  }

  unifyCategories(categories) {
    for (let i = 0; i < categories.length; i++) {
      this.unifiedCategories.push(categories[i]);
      if (categories[i].childHierarchicalProperties) {
        this.unifyCategories(categories[i].childHierarchicalProperties);
      }
    }
  }





  /** Llamadas */
  getProjection(getProjectionIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.exhitorsService.getProjection(getProjectionIn)
      .subscribe((data: object) => {
        this.getProjectionOk(data);
      },
        error => {
          this.getProjectionError(error);
        });

  }

  getProjectionOk(data) {
    this.loader.count--;
    this.projection = data;

  }

  getProjectionError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }


  getProductsDetails(getProductsDetailsIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.productsService.getProductsDetails(getProductsDetailsIn)
      .subscribe((data: object) => {
        this.getProductsDetailsOk(data);
      },
        error => {
          this.getProductsDetailsError(error);
        });

  }

  getProductsDetailsOk(data) {
    this.loader.count--;
    this.productsDetail = data;
    this.exhibitorId = data?.exhibitorId;
    this.updateExhibitorId();
  }

  getProductsDetailsError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }


  getProductsImages(getProductsImagesIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.productsService.getProductsImages(getProductsImagesIn)
      .subscribe((data: object) => {
        this.getProductsImagesOk(data);
      },
        error => {
          this.getProductsImagesError(error);
        });

  }

  getProductsImagesOk(data) {

    this.loader.count--;
    this.images = data._embedded.images;

    if (this.images.length < 1) {
      this.images[0] = {
        url: this.setExhibitorImage(''),
        id: 1
      }
    }

    if(this.images.length > 0)
      this.setActiveImage(this.images[0]);

  }

  getProductsImagesError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }



  getProductsCategories(getProductsCategoriesIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.productsService.getProductsCategories(getProductsCategoriesIn)
      .subscribe((data: object) => {
        this.getProductsCategoriesOk(data);
      },
        error => {
          this.getProductsCategoriesError(error);
        });

  }

  getProductsCategoriesOk(data) {

    this.loader.count--;
    this.productCategories = data;
    this.unifyCategories(data.masterProperties);

  }

  getProductsCategoriesError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  getHierarchicalProperties(getHierarchicalPropertiesIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.productsService.getHierarchicalProperties(getHierarchicalPropertiesIn)
      .subscribe((data: object) => {
        this.getHierarchicalPropertiesOk(data);
      },
        error => {
          this.getHierarchicalPropertiesError(error);
        });

  }

  getHierarchicalPropertiesOk(data) {

    this.loader.count--;
    this.hierarchicalProperties = data;
    this.unifyCategories(data);

  }

  getHierarchicalPropertiesError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }


  /** Fin Products */



  getFilesByCatalogueAndProduct(getFilesByCatalogueAndProductIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.catalogueService.getFilesByCatalogueAndProduct(getFilesByCatalogueAndProductIn)
      .subscribe((data: object) => {
        this.getFilesByCatalogueAndProductOk(data);
      },
        error => {
          this.getFilesByCatalogueAndProductError(error);
        });

  }

  getFilesByCatalogueAndProductOk(data) {

    this.loader.count--;
    this.files = data?._embedded?.files;

  }

  getFilesByCatalogueAndProductError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }


  getSocialNetworksByEvent(getSocialNetworksByEventIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.catalogueService.getSocialNetworksByEvent(getSocialNetworksByEventIn)
      .subscribe((data: object) => {
        this.getSocialNetworksByEventOk(data);
      },
        error => {
          this.getSocialNetworksByEventError(error);
        });

  }

  getSocialNetworksByEventOk(data) {

    this.loader.count--;
    this.socialNetworks = data;

  }

  getSocialNetworksByEventError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  getExhibitorMainImageUrl(getExhibitorMainImageUrlIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.exhitorsService.getExhibitorMainImageUrl(getExhibitorMainImageUrlIn)
      .subscribe((data: object) => {
        this.getExhibitorMainImageUrlOk(data);
      },
        error => {
          this.getExhibitorMainImageUrlError(error);
        });

  }

  getExhibitorMainImageUrlOk(data) {

    this.loader.count--;
    this.imageUrl = data;

  }

  getExhibitorMainImageUrlError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  goBack(): void {
    const queryParams = { filter: 'ONLY_PRODUCTS', lang: this.utilsService.mapLanguageCode(this.translateService.currentLang)};
    this.router.navigate([`${this.eventData?.eventName}/home`], {queryParams});
  }

  goExibitors(){
    const queryParams = { lang: this.utilsService.mapLanguageCode(this.translateService.currentLang)};
    this.router.navigate([`${this.catalogueId}/${this.eventData.eventName}/${'exhibitor'}/${this.projection?.id}/detail`], {queryParams});

  }

  goTo(url) {
    this.router.navigate([url]);
  }

  backToProducts() {
    let url = this.eventName + '/exhibitor-backoffice/exhibitors/' + this.exhibitorId + '/products';
    this.router.navigate([url]);
  }


  ngOnInit() {
    this.domService.addClassToBody('bg-gray');

    this.productDetail.productId = this.productId;
    this.productDetail.exhibitorId = this.exhibitorId;

    this.eventData = JSON.parse(this.sessionService.get('eventData', false) || '{}');
    this.catalogueProperties = JSON.parse(this.sessionService.get('catalogueProperties') || '{}');
    let eventName = this.eventData?.eventName;
    this.catalogueId = this.eventData?.id;


    let getProjectionIn = {
      exhibitorId: this.exhibitorId ,
      projection: 'detail'
    };

    let getProductsDetailsIn = {
      productId: this.productId,
      projectionType: 'detail'
    };

    let getProductsImagesIn = {
      productId: this.productId,
      projectionType: 'detail'
    };

    let getProductsCategoriesIn = {
      productId: this.productId
    };

    let getFilesByCatalogueAndProductIn = {
      catalogueId: this.catalogueId,
      productId: this.productId
    };

    let getSocialNetworksByEventIn = {
      event: eventName
    };

    let getExhibitorMainImageUrlIn = {
      exhibitorId: this.exhibitorId
    };

    this.getProductsDetails(getProductsDetailsIn);
    this.getProductsImages(getProductsImagesIn);
    this.getProductsCategories(getProductsCategoriesIn);
    this.getFilesByCatalogueAndProduct(getFilesByCatalogueAndProductIn);
    this.getSocialNetworksByEvent(getSocialNetworksByEventIn);

  }

  ngOnDestroy() {
    this.domService.removeClassFromBody('bg-gray');
  }

}
